import { forwardRef, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";
import { warningAccentBorderStyle } from "@/components/ui/feedback/warningVisual";

export type KpiCardAccent = "primary" | "success" | "warning" | "danger" | "info" | "none";

export type KpiCardProps = Omit<HTMLAttributes<HTMLDivElement>, "children"> & {
  label: ReactNode;
  value: ReactNode;
  accent?: KpiCardAccent;
  labelClassName?: string;
  valueClassName?: string;
};

const accentClassName: Record<KpiCardAccent, string> = {
  primary: "bfrs-border-l-primary",
  success: "bfrs-border-l-success",
  warning: "",
  danger: "bfrs-border-l-danger",
  info: "bfrs-border-l-info",
  none: "bfrs-border-l-border"
};

export const KpiCard = forwardRef<HTMLDivElement, KpiCardProps>(
  ({ className, labelClassName, valueClassName, label, value, accent = "primary", style, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "bfrs-flex bfrs-flex-col bfrs-justify-center bfrs-gap-1.5 bfrs-rounded-lg bfrs-border-y bfrs-border-r bfrs-border-l-[3px] bfrs-border-border bfrs-px-5 bfrs-py-[15px]",
        accentClassName[accent],
        className
      )}
      style={{ ...(accent === "warning" ? warningAccentBorderStyle : undefined), ...style }}
      {...props}
    >
      <span className={cn("bfrs-text-[12px] bfrs-font-medium bfrs-leading-normal bfrs-text-text-secondary", labelClassName)}>{label}</span>
      <span className={cn("bfrs-text-[16px] bfrs-font-bold bfrs-leading-normal bfrs-text-text-primary", valueClassName)}>{value}</span>
    </div>
  )
);

KpiCard.displayName = "KpiCard";
